import React from 'react';
import { DepartmentCockpit } from '../components/DepartmentCockpit';

export function CustomerPage() {
  return (
    <div className="pb-12">
      <DepartmentCockpit
        section="customer"
        pageTitle="Customer Experience"
        pageEyebrow="Customer"
        pageDescription="Voice-of-customer signals blended with retention and expansion KPIs."
      />
    </div>
  );
}
